import React from 'react';
import Head from 'next/head';
import { Button } from '@mui/material';

const TheFork = ({ link }) => {
  return (
    <>
      <Button
        variant="contained"
        sx={{
          backgroundColor: 'hsl(174, 100%, 20%) !important',
          color: 'white',
          '&:hover': {
            backgroundColor: 'hsl(174, 100%, 25%) !important',
          },
        }}
      >
        <a
          className="flex items-center justify-around"
          href={link}
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="mr-2"
          >
            <g clipPath="url(#clip0_2660_3693)">
              <path
                d="M13.9349 23.9876L13.9164 21.2552C13.9164 19.0563 16.5262 19.8546 16.1302 16.4331L15.3937 3.65392C15.3695 3.08134 14.6814 3.0707 14.7025 3.64351L14.5904 14.586C14.5335 15.4777 13.4759 15.3301 13.5095 14.3927L13.3736 3.63123C13.3736 2.98904 12.7051 3.11874 12.6989 3.67867L12.5165 14.6553C12.4952 15.3546 11.4608 15.2866 11.4824 14.6225L11.3275 3.6137C11.3275 3.11682 10.6904 3.06784 10.6771 3.55464L10.4909 14.6704C10.4412 15.4297 9.41957 15.3275 9.4725 14.5076L9.34457 3.64501C9.35278 3.0317 8.72371 3.06381 8.6947 3.64501L7.86098 16.9692C7.84139 19.8388 10.0712 18.9319 10.1219 21.3843L10.1191 24C1.98159 22.7424 -2.697 13.4045 1.67043 5.93856C6.34565 -2.05354 17.9119 -1.96026 22.4396 6.10599C26.6218 13.5565 21.928 22.6943 13.9349 23.9876Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_2660_3693">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
          Prenota un tavolo
        </a>
      </Button>
    </>
  );
};

export default TheFork;
